import React, { useState } from 'react';
import { Bell, User, ChevronDown, Users, LogOut, Settings } from 'lucide-react';
import { Link } from "react-router-dom";
import LogoutButton from './LogoutButton';
const NavbarComptable = ({ selectedClient, onClientChange, clients = [] }) => {
    const [isClientDropdownOpen, setIsClientDropdownOpen] = useState(false);
    const [isProfileDropdownOpen, setIsProfileDropdownOpen] = useState(false);



    return (
        <>
            <header className="main-navbar">
                <div className="navbar-container">
                    {/* Left Section - Logo */}
                    <div className="navbar-left">
                        <div className="logo-container">
                            <img src="../assets/images/cinef.png" alt="CINEF Logo" className="logo" />
                        </div>
                    </div>

                    {/* Right Section - Actions + Profile */}
                    <div className="navbar-right">
                        {/* Notifications */}
                        {/* <Link to="/notifications" className="nav-icon-btn notification-btn">
                            <Bell size={20} />
                            <span className="notification-badge">3</span>
                        </Link> */}


                        {/* Client Selector */}


                        {/* Profile Dropdown */}
                        <div className="profile-wrapper">
                            <button
                                className="profile-button"
                                onClick={() => setIsProfileDropdownOpen(!isProfileDropdownOpen)}
                            >
                                <div className="avatar-icon">
                                    <User size={20} />
                                </div>
                                <div className="profile-info">
                                    <span className="profile-name">Expert Comptable</span>
                                    <span className="profile-role">Administrateur</span>
                                </div>
                                <ChevronDown
                                    size={18}
                                    className={`profile-chevron ${isProfileDropdownOpen ? 'rotated' : ''}`}
                                />
                            </button>

                            {/* Profile Dropdown Menu */}
                            {isProfileDropdownOpen && (
                                <>
                                    <div
                                        className="dropdown-overlay"
                                        onClick={() => setIsProfileDropdownOpen(false)}
                                    />
                                    <div className="profile-dropdown">
                                        <div className="profile-dropdown-header">
                                            <div className="profile-dropdown-avatar">
                                                <User size={24} />
                                            </div>
                                            <div className="profile-dropdown-info">
                                                <p className="profile-dropdown-name">Cabinet</p>
                                                <p className="profile-dropdown-email">cinef-expertises</p>
                                            </div>
                                        </div>
                                        <div className="profile-dropdown-divider"></div>
                                        <div className="profile-dropdown-menu">
                                            <Link to="/parametres" className="profile-menu-item">
                                                <Settings size={18} />
                                                <span>Paramètres</span>
                                            </Link>

                                            <div className="profile-menu-item logout" style={{ padding: '0', background: 'transparent' }}>
                                                <LogoutButton 
                                                  variant="danger"
                                                  style={{ 
                                                    width: '100%', 
                                                    background: 'transparent', 
                                                    border: 'none',
                                                    color: '#dc3545',
                                                    justifyContent: 'flex-start',
                                                    padding: '8px 12px'
                                                  }}
                                                />
                                            </div>
                                        </div>

                                    </div>
                                </>
                            )}
                        </div>
                    </div>
                </div>
            </header>

            {/* Spacer for fixed navbar */}
            <div className="navbar-spacer"></div>

            <style>{`
                @import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&display=swap');

                * {
                    box-sizing: border-box;
                }

                .main-navbar {
                    background: linear-gradient(to right, #dc3545, #008A44);
                    box-shadow: 0px 4px 12px rgba(0,0,0,0.15);
                    border-bottom: 3px solid rgba(255, 255, 255, 0.2);
                    position: fixed;
                    top: 0;
                    left: 0;
                    right: 0;
                    z-index: 1050;
                    width: 100%;
                    font-family: 'Inter', 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
                }

                .navbar-container {
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    padding: 0 24px;
                    height: 80px;
                    max-width: 100%;
                    box-sizing: border-box;
                }

                .navbar-left {
                    display: flex;
                    align-items: center;
                    flex-shrink: 0;
                }

                .logo-container {
                    transition: transform 0.3s ease;
                }

                .logo-container:hover {
                    transform: translateY(-1px);
                }

                .logo {
                    height: 55px;
                    filter: drop-shadow(0 2px 4px rgba(0,0,0,0.15));
                    transition: transform 0.3s ease;
                }

                .logo:hover {
                    transform: scale(1.05);
                }

                /* Right Section */
                .navbar-right {
                    display: flex;
                    align-items: center;
                    gap: 12px;
                    flex-shrink: 0;
                }

                /* Dropdown Overlay */
                .dropdown-overlay {
                    position: fixed;
                    top: 0;
                    left: 0;
                    right: 0;
                    bottom: 0;
                    background: rgba(0, 0, 0, 0.3);
                    z-index: 1040;
                }

                /* Notification Button */
                .nav-icon-btn {
                    position: relative;
                    padding: 12px;
                    color: #ffffff;
                    background: rgba(255, 255, 255, 0.15);
                    border: none;
                    border-radius: 10px;
                    cursor: pointer;
                    transition: all 0.3s ease;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    backdrop-filter: blur(10px);
                    border: 1px solid rgba(255, 255, 255, 0.2);
                }

                .nav-icon-btn:hover {
                    background: rgba(255, 255, 255, 0.25);
                    transform: translateY(-2px);
                    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
                }

                .notification-badge {
                    position: absolute;
                    top: 6px;
                    right: 6px;
                    min-width: 18px;
                    height: 18px;
                    border-radius: 9px;
                    background: linear-gradient(135deg, #dc3545, #c82333);
                    color: white;
                    font-size: 11px;
                    font-weight: 600;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    border: 2px solid white;
                    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.3);
                    padding: 0 4px;
                }

                /* Client Section */
                .client-wrapper {
                    position: relative;
                }

                .client-btn:hover {
                    background: rgba(255, 255, 255, 0.25);
                }

                /* Client Dropdown Menu */
                .client-dropdown-menu {
                    position: absolute;
                    top: calc(100% + 10px);
                    right: 0;
                    width: 380px;
                    background: white;
                    border-radius: 16px;
                    box-shadow: 0 10px 40px rgba(0, 0, 0, 0.2);
                    z-index: 1060;
                    overflow: hidden;
                    animation: profileDropdownSlide 0.3s ease;
                }

                .client-dropdown-header {
                    padding: 20px;
                    background: linear-gradient(135deg, #008A44, #006834);
                    display: flex;
                    align-items: center;
                    gap: 12px;
                    color: white;
                }

                .client-dropdown-header h3 {
                    margin: 0;
                    font-size: 18px;
                    font-weight: 600;
                }

                .client-dropdown-divider {
                    height: 1px;
                    background: #e5e7eb;
                }

                .client-dropdown-list {
                    padding: 8px;
                    max-height: 400px;
                    overflow-y: auto;
                }

                .client-dropdown-item {
                    width: 100%;
                    display: flex;
                    align-items: center;
                    gap: 12px;
                    padding: 14px;
                    background: white;
                    border: 1px solid #e5e7eb;
                    border-radius: 12px;
                    cursor: pointer;
                    transition: all 0.2s ease;
                    margin-bottom: 6px;
                }

                .client-dropdown-item:hover {
                    background: #f0fdf4;
                    border-color: #008A44;
                    transform: translateX(4px);
                }

                .client-dropdown-item.active {
                    background: linear-gradient(135deg, rgba(0, 138, 68, 0.1), rgba(0, 138, 68, 0.05));
                    border-color: #008A44;
                    border-width: 2px;
                }

                .client-dropdown-icon {
                    width: 36px;
                    height: 36px;
                    background: linear-gradient(135deg, #008A44, #006834);
                    border-radius: 8px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    color: white;
                    flex-shrink: 0;
                }

                .client-dropdown-info {
                    flex: 1;
                    display: flex;
                    flex-direction: column;
                    align-items: flex-start;
                    gap: 4px;
                }

                .client-dropdown-name {
                    font-size: 15px;
                    font-weight: 600;
                    color: #1f2937;
                    line-height: 1.2;
                }

                .client-dropdown-type {
                    font-size: 13px;
                    color: #6b7280;
                    line-height: 1.2;
                }

                .client-status-badge {
                    padding: 4px 10px;
                    border-radius: 20px;
                    font-size: 12px;
                    font-weight: 500;
                    flex-shrink: 0;
                }

                .client-status-badge.active {
                    background: #d1fae5;
                    color: #065f46;
                }

                .client-status-badge.inactive {
                    background: #fee2e2;
                    color: #991b1b;
                }

                /* Profile Section */
                .profile-wrapper {
                    position: relative;
                }

                .profile-button {
                    display: flex;
                    align-items: center;
                    gap: 10px;
                    padding: 8px 12px;
                    background: rgba(255, 255, 255, 0.15);
                    backdrop-filter: blur(10px);
                    border: 1px solid rgba(255, 255, 255, 0.3);
                    border-radius: 12px;
                    cursor: pointer;
                    transition: all 0.3s ease;
                }

                .profile-button:hover {
                    background: rgba(255, 255, 255, 0.25);
                    transform: translateY(-2px);
                    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
                }

                .avatar-icon {
                    width: 44px;
                    height: 44px;
                    border-radius: 50%;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    background: linear-gradient(135deg, #ffffff, #f8f9fa);
                    border: 2px solid rgba(255, 255, 255, 0.5);
                    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
                    color: #dc3545;
                    flex-shrink: 0;
                }

                .profile-info {
                    display: flex;
                    flex-direction: column;
                    align-items: flex-start;
                }

                .profile-name {
                    font-size: 15px;
                    font-weight: 600;
                    color: #ffffff;
                    line-height: 1.2;
                    text-shadow: 0 1px 2px rgba(0, 0, 0, 0.2);
                }

                .profile-role {
                    font-size: 12px;
                    color: rgba(255, 255, 255, 0.85);
                    font-weight: 500;
                    text-shadow: 0 1px 1px rgba(0, 0, 0, 0.1);
                }

                .profile-chevron {
                    color: white;
                    transition: transform 0.3s ease;
                    flex-shrink: 0;
                }

                .profile-chevron.rotated {
                    transform: rotate(180deg);
                }

                /* Forms Section */
                .forms-wrapper {
                    position: relative;
                }

                .forms-btn:hover {
                    background: rgba(255, 255, 255, 0.25);
                }

                /* Forms Dropdown */
                .forms-dropdown {
                    position: absolute;
                    top: calc(100% + 10px);
                    right: 0;
                    width: 320px;
                    background: white;
                    border-radius: 16px;
                    box-shadow: 0 10px 40px rgba(0, 0, 0, 0.2);
                    z-index: 1060;
                    overflow: hidden;
                    animation: profileDropdownSlide 0.3s ease;
                }

                .forms-dropdown-header {
                    padding: 20px;
                    background: linear-gradient(135deg, #008A44, #006834);
                    display: flex;
                    align-items: center;
                    gap: 12px;
                    color: white;
                }

                .forms-dropdown-header h3 {
                    margin: 0;
                    font-size: 18px;
                    font-weight: 600;
                }

                .forms-dropdown-divider {
                    height: 1px;
                    background: #e5e7eb;
                }

                .forms-dropdown-menu {
                    padding: 8px;
                    max-height: 400px;
                    overflow-y: auto;
                }

                .forms-menu-item {
                    width: 100%;
                    display: flex;
                    align-items: center;
                    padding: 14px 16px;
                    background: white;
                    border: none;
                    border-radius: 10px;
                    cursor: pointer;
                    transition: all 0.2s ease;
                    margin-bottom: 4px;
                }

                .forms-menu-item:hover {
                    background: #f0fdf4;
                    transform: translateX(4px);
                }

                .forms-item-content {
                    display: flex;
                    flex-direction: column;
                    align-items: flex-start;
                    gap: 4px;
                }

                .forms-item-title {
                    font-size: 15px;
                    font-weight: 600;
                    color: #1f2937;
                    line-height: 1.2;
                }

                .forms-item-desc {
                    font-size: 13px;
                    color: #6b7280;
                    line-height: 1.2;
                }

                /* Profile Dropdown */
                .profile-dropdown {
                    position: absolute;
                    top: calc(100% + 10px);
                    right: 0;
                    width: 280px;
                    background: white;
                    border-radius: 16px;
                    box-shadow: 0 10px 40px rgba(0, 0, 0, 0.2);
                    z-index: 1060;
                    overflow: hidden;
                    animation: profileDropdownSlide 0.3s ease;
                    max-width: Calculator(100vw - 32px);
                    margin-right: 0;
                }

                @keyframes profileDropdownSlide {
                    from {
                        opacity: 0;
                        transform: translateY(-10px);
                    }
                    to {
                        opacity: 1;
                        transform: translateY(0);
                    }
                }

                .profile-dropdown-header {
                    padding: 20px;
                    background: linear-gradient(135deg, #dc3545, #c82333);
                    display: flex;
                    align-items: center;
                    gap: 12px;
                }

                .profile-dropdown-avatar {
                    width: 50px;
                    height: 50px;
                    border-radius: 50%;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    background: white;
                    color: #dc3545;
                    flex-shrink: 0;
                }

                .profile-dropdown-info {
                    flex: 1;
                    min-width: 0;
                }

                .profile-dropdown-name {
                    margin: 0;
                    font-size: 16px;
                    font-weight: 600;
                    color: white;
                    line-height: 1.3;
                }

                .profile-dropdown-email {
                    margin: 4px 0 0 0;
                    font-size: 13px;
                    color: rgba(255, 255, 255, 0.9);
                    line-height: 1.2;
                }

                .profile-dropdown-divider {
                    height: 1px;
                    background: #e5e7eb;
                }

                .profile-dropdown-menu {
                    padding: 8px;
                }

                .profile-menu-item {
                    width: 100%;
                    display: flex;
                    align-items: center;
                    gap: 12px;
                    padding: 12px 16px;
                    background: white;
                    border: none;
                    border-radius: 10px;
                    cursor: pointer;
                    transition: all 0.2s ease;
                    font-size: 15px;
                    font-weight: 500;
                    color: #1f2937;
                    margin-bottom: 4px;
                }

                .profile-menu-item:hover {
                    background: #f3f4f6;
                }

                .profile-menu-item.logout {
                    color: #dc3545;
                    margin-top: 4px;
                }

                .profile-menu-item.logout:hover {
                    background: #fee2e2;
                }

                .profile-menu-item svg {
                    flex-shrink: 0;
                }

                .navbar-spacer {
                    height: 80px;
                }

                /* Responsive Design */
                @media (max-width: 1200px) {
                    .navbar-container {
                        padding: 0 16px;
                    }
                    
                    .client-selector {
                        min-width: 250px;
                    }

                    .client-dropdown {
                        width: 350px;
                    }
                }

                @media (max-width: 768px) {
                    .navbar-container {
                        padding: 0 12px;
                        height: 70px;
                    }

                    .client-selector {
                        min-width: 200px;
                        padding: 10px 14px;
                    }

                    .client-name {
                        font-size: 14px;
                    }

                    .client-dropdown {
                        width: 300px;
                    }

                    .profile-info {
                        display: none;
                    }

                    .profile-button {
                        padding: 8px;
                    }

                    .navbar-spacer {
                        height: 70px;
                    }
                }

                @media (max-width: 480px) {
                    .navbar-container {
                        padding: 0 8px;
                        height: 65px;
                    }

                    .logo {
                        height: 45px;
                    }

                    .navbar-right {
                        gap: 8px;
                    }

                    .profile-dropdown {
                        width: 260px;
                        max-width: calc(100vw - 16px);
                    }

                    .navbar-spacer {
                        height: 65px;
                    }

                    .avatar-icon {
                        width: 40px;
                        height: 40px;
                    }
                }
            `}</style>
        </>
    );
};

export default NavbarComptable;